<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit">
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="nome"
            v-validate="'required'"
            :class="{'is-invalid' : errors.has('nome')}"
            v-model="form.nome"
            class="form-control form-control-sm"
          />
          <span class="invalid-feedback" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Descrição:</label>
        <div class="col-sm-10">
          <input
            type="text"
            name="descricao"
            v-validate="'required'"
            :class="{'is-invalid' : errors.has('descricao')}"
            v-model="form.descricao"
            class="form-control form-control-sm"
          />
          <span
            class="invalid-feedback"
            v-show="errors.has('descricao')"
          >{{ errors.first('descricao') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">*Cor:</label>
        <div class="col-sm-2">
          <input
            type="color"
            name="cor"
            v-validate="'required'"
            :class="{'is-invalid' : errors.has('cor')}"
            v-model="form.cor"
            class="form-control form-control-sm"
          />
          <span class="invalid-feedback" v-show="errors.has('cor')">{{ errors.first('cor') }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label col-form-label-sm">Status:</label>
        <div class="col-sm-10">
          <select
            v-model="form.idStatus"
            name="idStatus"
            v-validate="'required'"
            :class="{'is-invalid' : errors.has('idStatus')}"
            class="form-control form-control-sm"
          >
            <option value="0">Escolha</option>
            <option v-for="item in status" :key="item.id" :value="item.id">{{item.descricao}}</option>
          </select>
          <span
            class="invalid-feedback"
            v-show="errors.has('idStatus')"
          >{{ errors.first('idStatus') }}</span>
        </div>
      </div>

      <hr />

      <div class="row">
        <div class="col-sm-12 text-right">
          <small class="float-left text-info">
            <fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.
          </small>
          <button class="btn btn-success btn-sm">
            <fa-icon icon="check" transform="left-3" />SALVAR
          </button>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import _ from "lodash";
import axios from "../../../routers/axios";
export default {
  data() {
    return {
      tipoTicket: [],
      status: [],
      form: {
        id: 0,
        nome: "",
        descricao: "",
        cor: "",
        idServico: 0
      }
    };
  },

  mounted() {
    axios.get(this._getUrl("api/status")).then(response => {
      if (response.status == 200) {
        this.status = response.data;
      }
    });
  },

  methods: {
    editar(item) {
      this.form.id = item.id;
      this.form.nome = item.nome;
      this.form.descricao = item.descricao;
      this.form.cor = item.cor;
      this.form.idStatus = item.idStatus;
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.salva();
        }
      });
    },

    salva() {
      var data = {
        id: this.form.id,
        nome: this.form.nome,
        descricao: this.form.descricao,
        cor: this.form.cor,
        idStatus: this.form.idStatus
      };

      this.$notify.loadIn("Salvando");

      if (this.form.id != 0) {
        axios
          .put(this._getUrl("api/projeto") + "/" + this.form.id, data)
          .then(response => {
            this.$emit("item-salvo", response.data);
          });
      } else {
        axios.post(this._getUrl("api/projeto"), data).then(response => {
          this.form.id = response.data.id;
          this.$emit("item-salvo", response.data);
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/projeto/cadastro.vue